import React from "react";

import SearchAndBrowseIconGrid from "icons/SearchAndBrowseIconGrid";
import SegmentedControlResults from "core/SegmentedControlResults";

import useLoadMore from "frontend/hooks/useLoadMore";

import { GET_SIMILAR_ICONS_DATA } from "icons/SimilarIcons/queries";

const SearchIconsResults = ({ isActive, query }) => {
    const { items, ...paginationResults } = useLoadMore({
        limit: 1,
        query: GET_SIMILAR_ICONS_DATA,
        queryVariables: { iconId: 14235 },
        pathToListKey: "similarIcons.items",
        pathToTotalCountKey: "similarIcons.totalCount",
        fetchItemsOnLoad: false,
        pageQueryParamKey: "iconspage"
    });

    return (
        <SegmentedControlResults isActive={isActive} {...paginationResults}>
            <SearchAndBrowseIconGrid iconData={items} />
        </SegmentedControlResults>
    );
};

export default SearchIconsResults;
